import React, { useEffect } from 'react'
import { connect } from 'react-redux'

import { SessionMap } from '@src/firebase-util/types'

import { ProjectIdentity, RootStateTypeExtra } from '@store/types'

import ResetUtil from '@utilities/reset-util'

import FirebaseControlQuery from '@firebaseUtil/firebase-control-query'

import useClearCache from '@hooks/useClearCache'

interface ErrorHandlerFallbackProps {
  projectIdentity: ProjectIdentity
  session: SessionMap | undefined
}

function ErrorHandler({ projectIdentity, session }: ErrorHandlerFallbackProps) {
  const firebaseControlQuery = FirebaseControlQuery({
    ...projectIdentity,
    sessionKey: projectIdentity.sessionId,
  })

  const [isCacheCleared, handleClearCache] = useClearCache({
    projectIdentity,
    session,
  })

  const [isRefreshing, setIsRefreshing] = React.useState(false)
  const { resetLocalStorage } = ResetUtil()

  const handleRefreshClick = async () => {
    setIsRefreshing(true)
    try {
      await firebaseControlQuery.updateSessionMapOfActiveSession()
    } catch (error) {
      console.log(error)
    } finally {
      handleClearCache()
    }
  }

  useEffect(() => {
    if (isCacheCleared) {
      firebaseControlQuery
        .update({
          [`activeRoute`]: 'vision',
        })
        .finally(() => {
          resetLocalStorage()
          setIsRefreshing(false)
          window.location.reload()
        })
    }
  }, [isCacheCleared])

  return (
    <div className="flex h-full w-full flex-col justify-center p-4">
      <div className="flex flex-col items-center justify-center rounded-full bg-secondaryColour p-16">
        <h3 className="mb-6 text-center text-5xl font-bold">
          New updates available!
        </h3>
        <p className="mb-6 text-center text-2xl">
          It looks like this page hasn&apos;t loaded correctly, possibly due to
          recent updates. Please go back to the main page or use the menu to
          explore other sections. Alternatively, click below to refresh.
        </p>
        <div>
          <button
            type="button"
            className={`rounded-lg bg-tertiaryColour px-4 py-2 text-xl text-neutralColour ${isRefreshing ? 'animate-pulse' : ''}`}
            onClick={handleRefreshClick}
            disabled={isRefreshing}
          >
            Refresh Now
          </button>
        </div>
      </div>
    </div>
  )
}

export default connect(
  ({ projectIdentity, firestore: { session } }: RootStateTypeExtra) => ({
    projectIdentity,
    session,
  })
)(ErrorHandler)
